import { css } from 'linaria';

export const productPriceWrapper = css`
  margin-bottom: 8px;
`;

export const productPrice = css`
  && {
    font-weight: 800;
  }
`;

export const productPriceCurrency = css`
  && {
    font-weight: 700;
  }
`;
